export const Login = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M479.62-108v-86h274.07q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-547.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H479.62v-86h274.07q41.03 0 69.67 28.64T852-753.69v547.38q0 41.03-28.64 69.67T753.69-108H479.62Zm-88.23-161.23-62.54-63.39L434.23-438H108v-86h326.23L328.85-629.38l62.54-61.39L602.15-480 391.39-269.23Z" />
  </svg>
);
